import {
  HANDWRITING_FONTS,
  SERIF_FONTS,
} from 'app/app.quotion.co/[isEU]/(dashboard)/site/[subdomain]/(shrinked-sidebar)/design/all/constants';

export function getFontStylesheetUrl(
  font?: string | null,
  styles: 'all' | 'regular' = 'all',
) {
  const family = font?.replace(/ /g, '+') || 'Inter';
  const familyWithStyles =
    font === 'Caveat'
      ? 'Caveat:wght@400..700'
      : font === 'Lora'
        ? 'Lora:ital,wght@0,400..700;1,400..700'
        : styles === 'regular'
          ? family
          : `${family}:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900`;
  return `https://fonts.googleapis.com/css2?family=${familyWithStyles}&display=swap`;
}

export const SANS_SERIF_FONT_FALLBACKS = [
  'system-ui',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  // 'Arial',
  '"Noto Sans"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];

export const SERIF_FONT_FALLBACKS = [
  'ui-serif',
  'Georgia',
  'Cambria',
  '"Times New Roman"',
  'Times',
  'serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];

export function getFontFamily(font?: string | null) {
  let fonts = [font ? `"${font}"` : '"Inter"', ...SANS_SERIF_FONT_FALLBACKS];
  if (font && SERIF_FONTS.includes(font)) {
    fonts = [`"${font}"`, ...SERIF_FONT_FALLBACKS];
  }
  if (font && HANDWRITING_FONTS.includes(font)) {
    fonts = [
      `"${font}"`,
      '"Kaiti SC"',
      'STKaiti',
      'KaiTi',
      ...SERIF_FONT_FALLBACKS,
    ];
  }
  return fonts.join(',');
}
